import { HmlEnvironment as ImportedHmlEnvironment } from "@packages/config";
import type { Config } from "../config.contract";

export class HmlEnvironment
  extends ImportedHmlEnvironment
  implements Config
{
  // Favorites usa a mesma propriedade Adobe Launch da garagem (dd5a99595f9f),
  // distinta da propriedade padrão do next.ui (home/search).
  adobeSDK =
    "https://assets.adobedtm.com/0a9348ad03c2/dd5a99595f9f/launch-f4e34f64effa-development.min.js";
  enableDatadog = true;
  traceSampleRate = 100;
  sessionSampleRate = 100;
  sessionReplaySampleRate = 100;
}
